export default __webpack_public_path__ + "static/media/cd_log.fb1a47b3.svg";